import Vue from 'vue'
import moment from 'vue-moment'
import 'moment/locale/ru'

Vue.prototype.moment = moment
